import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { as as a, aW as d, d as f } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as h } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as b } from "../../utils/omitStyleRenderProps/index.js";
import { FieldDescription as w } from "../FieldDescription/index.js";
import { FieldLabel as u } from "../FieldLabel/index.js";
import '../../assets/index55.css';const x = "_switchWrapper_1wprr_1", N = "_control_1wprr_41", $ = "_track_1wprr_47", R = "_thumb_1wprr_60", W = "_compact_1wprr_111", j = "_label_1wprr_122", r = {
  switchWrapper: x,
  switch: "_switch_1wprr_1",
  control: N,
  track: $,
  thumb: R,
  compact: W,
  label: j
}, L = h(
  ({ children: o, description: s, compact: e = !1, labelRef: p, autoFocus_I_READ_THE_JSDOC: l, ...i }, n) => {
    const m = a(n), _ = a(p);
    return /* @__PURE__ */ c(
      "div",
      {
        "data-component": "Switch",
        className: f(r.switchWrapper, e ? r.compact : null),
        children: [
          /* @__PURE__ */ c(
            d,
            {
              ...b(i),
              slot: void 0,
              autoFocus: l,
              ref: _,
              inputRef: m,
              className: r.switch,
              children: [
                /* @__PURE__ */ t(u, { className: r.label, children: o }),
                /* @__PURE__ */ t("span", { className: r.control, "aria-hidden": "true", children: /* @__PURE__ */ t("span", { className: r.track, children: /* @__PURE__ */ t("span", { className: r.thumb }) }) })
              ]
            }
          ),
          /* @__PURE__ */ t(w, { children: s })
        ]
      }
    );
  }
);
export {
  L as Switch
};
